var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"smvp-overlay-widget",style:(_vm.style)},[(_vm.imgUrl)?_c('img',{attrs:{"src":_vm.imgUrl}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }